import { gql, useMutation } from '@apollo/client';

const useUpdateTeamMembers = (onCompleted = () => {}, onError = () => {}) => {
  return useMutation(
    gql`
      mutation($planId: ID!, $counselorId: ID, $headId: ID) {
        updateTeamCounselingPlan(
          planId: $planId
          counselorId: $counselorId
          headId: $headId
        ) {
          ... on CouncelingPlan {
            head {
              teamUserId
              firstName
              lastName
            }
            councelor {
              teamUserId
              firstName
              lastName
            }
          }
        }
      }
    `,
    {
      onCompleted,
      onError,
    }
  );
};

export default useUpdateTeamMembers;
